import gql from "graphql-tag";

export const GetOrders = gql`
  query GetOrders(
    $id: QueryableInt
    $name: QueryableString
    $createdAt: QueryableDateTime
    $quantity: QueryableInt
    $amount: QueryableFloat
    $status: QueryableString
    $address: QueryableString
    $buyer: QueryableString
    $seller: QueryableString
    $email: QueryableString
    $cursor: String
    $limit: Int
  ) {
    orders(
      order: {
        id: $id
        product: { name: $name }
        createdAt: $createdAt
        quantity: $quantity
        amount: $amount
        address: $address
        buyer: { name: $buyer }
        seller: { name: $seller }
        status: $status
        email: $email
        cursor: $cursor
        limit: $limit
      }
    ) {
      id
      email
      amount
      status
      isDonation
      createdAt
      quantity
      customerNote
      employer
      occupation
      viewingToken
      product {
        id
        name
        selectedValues{
          name
        }
      }

      destination {
        id
        name
        street1
        city
        state {
          id
          name
        }
        postalCode
      }
      employerAddress{
        id
        name
        street1
        city
        state {
          id
          name
        }
        postalCode
      }

      seller {
        id
        name
      }
    }
  }
`;
